import { useRef } from 'react'

import useStaggerMotion from 'hooks/useStaggerMotion'

import ResponsiveImage from 'components/ResponsiveImage'

import { resultCountValues } from '../config'
import s from '../EnglishHome.module.css'

export default function ResultSection() {
  const animationRef = useRef(null)
  useStaggerMotion(animationRef, 0, s.active, '0px 0px 0px 0px', 0.5)

  return (
    <section className={s.result}>
      <div className={s.inner}>
        <ul className={s.countList} ref={animationRef}>
          {resultCountValues.map(({ pc, mo, alt }, index) => {
            return (
              <li key={index}>
                <ResponsiveImage pc={pc} mo={mo} alt={alt} maxWidth={1024} />
              </li>
            )
          })}
        </ul>
        <p className={s.summary}>*유료 수강생 4,854명 조사 결과 (2019.12)</p>
      </div>
    </section>
  )
}
